import { render } from "./FooterView.vue?vue&type=template&id=74ef0bf0&scoped=true&ts=true"
import script from "./FooterView.vue?vue&type=script&lang=ts"
export * from "./FooterView.vue?vue&type=script&lang=ts"

import "./FooterView.vue?vue&type=style&index=0&id=74ef0bf0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ef0bf0"]])

export default __exports__